/**
 * SYeN 2026.09.02 - на мобильном название+цена+рейтинг выше фото
 *
 * На мобильном (<768px) .product-info у этой темы вообще не flex (flex
 * появляется только через @media (min-width: 768px) в main.css) — на
 * мобильном .media-gallery (фото) и .detail (весь остальной блок товара)
 * просто идут друг за другом в DOM-порядке, фото первым. Чтобы поднять
 * название/цену/рейтинг НАД фото только на мобильном, не трогая десктопный
 * двухколоночный layout, переносим два конкретных блока
 * (.title-row/.price-container) перед .media-gallery через JS, а не
 * переписываем секцию в Liquid — они рендерятся глубоко внутри цикла по
 * section.blocks (main-product.liquid), выдёргивать их оттуда Liquid'ом
 * пришлось бы переделкой общего цикла для всех блоков сразу.
 *
 * Только на мобильной ширине (matchMedia, тот же брейкпоинт 768px, что и
 * в CSS) — на десктопе ничего не трогаем вообще.
 *
 * SYeN 2026.09.02 - цветовые группы Globo не должны уезжать вместе с ценой
 * Приложение Globo Swatch асинхронно вставляет "цветовые группы" товара
 * (.globo-product-groups-detail — кружки других цветов) ВНУТРЬ
 * .price-container (в форму .js-instalments-form / .price-descriptors —
 * их собственный якорь для инъекции, а не наш выбор). Раз это потомок
 * price-container, а не сосед — при переносе цены наверх он уезжал вместе
 * с ней. Ловим появление через MutationObserver и возвращаем именно этот
 * элемент туда, где раньше физически заканчивался price-container (перед
 * тем, что шло дальше — divider/состав ткани/размер) — то есть "вниз".
 */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var productInfo = document.querySelector('product-form.product-info');
  var mediaGallery = productInfo ? productInfo.querySelector(':scope > .media-gallery') : null;
  if (!mediaGallery) return;

  var titleRow = productInfo.querySelector('.detail .title-row');
  var priceContainer = productInfo.querySelector('.detail .price-container');
  if (!titleRow && !priceContainer) return;

  var wrap = document.createElement('div');
  wrap.className = 'mobile-title-price-above-media';

  if (priceContainer) {
    // Запоминаем точку "тут раньше был price-container" ДО переноса, чтобы
    // было куда вернуть цветовые группы, если Globo вставит их внутрь.
    var originalParent = priceContainer.parentElement;
    var originalNextSibling = priceContainer.nextSibling;

    var watchColorGroups = function () {
      var groups = priceContainer.querySelector('.globo-product-groups-detail');
      if (!groups) return false;
      originalParent.insertBefore(groups, originalNextSibling);
      return true;
    };

    if (!watchColorGroups()) {
      var observer = new MutationObserver(function () {
        if (watchColorGroups()) observer.disconnect();
      });
      observer.observe(priceContainer, { childList: true, subtree: true });
      // Globo не найден/не установлен на товаре — не ждём вечно
      setTimeout(function () { observer.disconnect(); }, 8000);
    }
  }

  if (titleRow) wrap.appendChild(titleRow);
  if (priceContainer) wrap.appendChild(priceContainer);

  mediaGallery.parentElement.insertBefore(wrap, mediaGallery);
});
